module.exports = __webpack_public_path__ + "img/shaved-ice.0c975099.svg";